import React, { useState } from 'react';
import { Mail, X, Loader2, CheckCircle } from 'lucide-react';
import { apiFetch } from '../utils/api';

/** Purpose: Executes { on dismiss }. Inputs: { onDismiss }. Output: Operation result. */
export default function VerificationBanner({ onDismiss }) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  /** Purpose: Executes resend email. Inputs: none. Output: Promise with operation result. */
  const resendEmail = async () => {
    setSending(true);
    try {
      const response = await apiFetch('/auth/resend-verification', {
        method: 'POST'
      });

      if (response.ok) {
        setSent(true);
      }
    } catch (err) {
      console.error('Failed to resend:', err);
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div className="bg-green-50 border-b border-green-200 px-4 py-3">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <CheckCircle className="w-5 h-5 text-green-600" />
            <p className="text-green-800 text-sm">
              Verification email sent! Check your inbox.
            </p>
          </div>
          <button onClick={onDismiss} className="text-green-600 hover:text-green-800">
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-3">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Mail className="w-5 h-5 text-amber-600" />
          <p className="text-amber-800 text-sm">
            Please verify your email address to access all features.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={resendEmail}
            disabled={sending}
            className="text-amber-800 hover:text-amber-900 text-sm font-medium underline flex items-center gap-1"
          >
            {sending ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Sending...
              </>
            ) : (
              'Resend Email'
            )}
          </button>
          <button onClick={onDismiss} className="text-amber-600 hover:text-amber-800">
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
